import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportTypeStep = ({ formData, onInputChange }) => {
  const reportTypes = [
    {
      value: 'consultation',
      label: 'Consultation',
      description: 'Première consultation, diagnostic, plan de traitement',
      icon: 'FileText'
    },
    {
      value: 'cbct',
      label: 'CBCT / Imagerie',
      description: 'Analyse d\'imagerie 3D, compte rendu radiologique',
      icon: 'Scan'
    },
    {
      value: 'rte_treatment',
      label: 'Traitement endodontique',
      description: 'Traitement canalaire, reprise, obturation',
      icon: 'Activity'
    },
    {
      value: 'surgery',
      label: 'Chirurgie',
      description: 'Résection apicale, extraction, chirurgie endodontique',
      icon: 'Scissors'
    },
    {
      value: 'custom',
      label: 'Personnalisé',
      description: 'Compte rendu libre, autre type d\'intervention',
      icon: 'Edit'
    }
  ];

  const handleTypeSelect = (type) => {
    onInputChange({ target: { name: 'reportType', value: type } });
  };

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-white mb-2">Type de compte rendu</h2>
        <p className="text-gray-400">Sélectionnez le type de compte rendu à générer</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {reportTypes?.map(type => (
          <button
            key={type?.value}
            type="button"
            onClick={() => handleTypeSelect(type?.value)}
            className={`
              relative p-6 rounded-2xl border-2 transition-all duration-300
              ${formData?.reportType === type?.value
                ? 'border-blue-500 bg-blue-500/10 shadow-lg shadow-blue-500/20'
                : 'border-white/10 bg-gray-900/50 hover:border-white/20 hover:bg-gray-800/50'
              }
            `}
          >
            <div className="flex items-start gap-4">
              <div className={`
                p-3 rounded-xl
                ${formData?.reportType === type?.value
                  ? 'bg-blue-500/20 text-blue-400' :'bg-gray-800/50 text-gray-400'
                }
              `}>
                <Icon name={type?.icon} size={24} />
              </div>
              <div className="flex-1 text-left">
                <h3 className="text-lg font-semibold text-white mb-1">{type?.label}</h3>
                <p className="text-sm text-gray-400">{type?.description}</p>
              </div>
              {formData?.reportType === type?.value && (
                <Icon name="CheckCircle2" size={20} className="text-blue-400" />
              )}
            </div>
          </button>
        ))}
      </div>

      {/* Clinical Data Fields */}
      {formData?.reportType && (
        <div className="bg-gradient-to-br from-gray-900/50 to-gray-800/30 backdrop-blur-xl border border-white/10 rounded-2xl p-8 mt-8">
          <h3 className="text-xl font-semibold text-white mb-6 flex items-center gap-3">
            <Icon name="ClipboardList" size={24} className="text-purple-400" />
            Informations cliniques
          </h3>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Dent(s) concernée(s)
              </label>
              <input
                type="text"
                name="toothNumbers"
                value={formData?.toothNumbers}
                onChange={onInputChange}
                placeholder="16, 17, 26"
                className="w-full px-4 py-3 bg-gray-900/50 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-blue-500/50"
              />
              <p className="text-xs text-gray-500 mt-1">Séparez les numéros par des virgules</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Diagnostic
              </label>
              <input
                type="text"
                name="diagnosis"
                value={formData?.diagnosis}
                onChange={onInputChange}
                placeholder="Pulpite irréversible"
                className="w-full px-4 py-3 bg-gray-900/50 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-blue-500/50"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Actes réalisés (optionnel)
              </label>
              <input
                type="text"
                name="procedures"
                value={formData?.procedures}
                onChange={onInputChange}
                placeholder="Traitement canalaire, obturation"
                className="w-full px-4 py-3 bg-gray-900/50 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-blue-500/50"
              />
              <p className="text-xs text-gray-500 mt-1">Séparez les actes par des virgules</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportTypeStep;